import { isObject } from 'common/utils/object'

function formatOptions(object: any): any {
  const newObject = {}

  for (let key in object) {
    const value = object[key]

    if (Array.isArray(value) || isObject(value) || value instanceof Date) {
      newObject[key] = JSON.stringify(value)
    } else {
      newObject[key] = value
    }
  }

  return newObject
}

export default formatOptions
